import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFWmsEntities } from '@pf/shared-common';
import { AsnHeaderRead } from '../../entities/asn-header.dto';

@Injectable()
export class AsnHeaderStore extends AbstractEntityStore<AsnHeaderRead> {
    constructor() {
        super(PFWmsEntities.AsnHeader);
    }
}
